import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';
import BannerIndex from '@/views/auth/banner/index.vue';
import BannerEdit from '@/views/auth/banner/_id.vue';

export default [
    {
        path: '/banner',
        name: 'banner',
        component: BannerIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('banner'),
        },
    },
    {
        path: '/banner/:id',
        component: BannerEdit,
        name: 'banner-edit',
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('banner'),
        },
    },
];
